"use client"

import type { QuickServiceContentProps } from "@/types/types"
import { useQuickService } from "../../../../../../../../hook/useQuickService"
import { QuickServiceItem } from "./QuickServiceItem"

export const QuickServiceContent = ({ id, title, items = [], className = "" }: QuickServiceContentProps) => {
  const {
    id: componentId,
    validItems,
    hasValidItems,
  } = useQuickService({
    items,
    componentId: id,
  })

  if (!hasValidItems) {
    return null
  }

  // Kiểm tra xem item có đủ properties để bật hover effect hay không
  const shouldEnableHover = (item: any) => {
    return !!(item.icon || item.title || item.description)
  }

  const leftItems = validItems.slice(0, 2)
  const rightItem = validItems[2]

  return (
    <div id={componentId} className={`w-full ${className}`}>
      <div className="mx-auto max-w-[1290px] px-4 pt-7 pb-4 sm:px-0 sm:pt-16 sm:pb-7">
        {title && (
          <h2 className="text-left text-lg sm:text-2xl font-bold sm:leading-[2.3125rem] leading-[1.625rem] pb-6 text-[#333333]">
            {title}
          </h2>
        )}

        {/* Desktop layout */}
        {/* 523.7px + 742.3px + 24px (gap) = 1290px -> tỉ lệ trên tổng container ~40.6% / 57.6% */}
        <div className="hidden sm:grid sm:grid-cols-[40.6%_57.6%] sm:gap-6 overflow-hidden">
          <div className="flex flex-col gap-5">
            {leftItems.map((item, index) => (
              <QuickServiceItem
                key={index}
                item={item}
                enableHover={shouldEnableHover(item)}
                className="sm:max-w-none"
                index={index}
              />
            ))}
          </div>

          {rightItem && (
            <div className="flex h-full overflow-hidden">
              <QuickServiceItem
                item={rightItem}
                isLarge
                enableHover={shouldEnableHover(rightItem)}
                className="sm:max-w-none w-full"
              />
            </div>
          )}
        </div>

        {/* Mobile layout */}
        <div className="flex flex-col gap-6 sm:hidden">
          {validItems.map((item, index) => (
            <QuickServiceItem key={index} item={item} enableHover={shouldEnableHover(item)} index={index} />
          ))}
        </div>
      </div>
    </div>
  )
}
